import { render, staticRenderFns } from "./NewsTag.vue?vue&type=template&id=066569db&scoped=true"
import script from "./NewsTag.vue?vue&type=script&lang=js"
export * from "./NewsTag.vue?vue&type=script&lang=js"
import style0 from "./NewsTag.vue?vue&type=style&index=0&id=066569db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066569db",
  null
  
)

export default component.exports